<template>
  <div id="cancelation-policy">
    <div class="grid">
      <div class="grid-title">
        <h4>{{ $t("CANCELATION_POLICY") }}</h4>
        <v-btn color="primary" class="pl-10 pr-10" @click="addCancellation">
          <v-icon dark>
              mdi-plus
          </v-icon>
          {{ $t("ADD_NEW") }}
        </v-btn>
      </div>
      <div class="grid-body p-3 pb-0">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th v-for="header in headers" :class="header.class">
                  <div>
                    {{ header.text }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="dataTable.length > 0">
                <tr v-for="(item, i) in dataTable">
                  <td class="text-center vertical-middle">{{ paging.offset + i + 1 }}</td>
                  <td class="font-weight-bold vertical-middle">
                    <a
                      class="app-link text-decoration-none"
                      href="javascript:;"
                      @click="editItem(item)"
                    >
                      {{ item.nameVi }}
                    </a>
                  </td>
                  <td class="svertical-middle">
                    <span v-if="item.cancellationI18n.length > 0" >{{item.cancellationI18n.find(x => x.lang == defaultI18n).description}}</span>
                  </td>
                  <td class="text-center vertical-middle">
                    <div class="d-flex justify-center">
                      <v-switch
                        v-model="item.status"
                        class="item-switch m-0 p-0"
                        @change="changeStatus(item)"
                      ></v-switch>
                    </div>
                  </td>
                  <td class="text-center vertical-middle">
                    <v-tooltip top transition="slide-y-reverse-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          depressed
                          @click="editItem(item)"
                          x-small
                          class="rounded-sm mr-1"
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          outlined
                        >
                          <v-icon size="15">
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                      </template>
                      {{ $t("EDIT") }}
                    </v-tooltip>
                    <v-tooltip top transition="slide-y-reverse-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          depressed
                          color="error"
                          @click="$refs.deleteDialogComponent.open(item)"
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          class="rounded-sm"
                          outlined
                        >
                          <v-icon size="15">
                            delete
                          </v-icon>
                        </v-btn>
                      </template>
                      {{ $t("DELETE") }}
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                    {{ $t('NO_DATA') }}
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>

        <paging
          v-if="paging.total"
          :paging.sync="paging"
          @changePage="changePage"
        >
          <span slot="totalItems" v-if="paging"
            >{{ $t("TOTAL") }}: {{ paging.total }}
            {{ $t("POLICY") }}</span
          >
        </paging>

        <!-- <paging v-if="paging.total" :paging.sync="paging" @changePage="initialize">
          <span
            slot="totalItems"
            v-if="paging"
          >{{ $t("TOTAL") }}: {{ totalItems }} {{ $t("POLICY") }}</span>
        </paging> -->
      </div>
    </div>
    <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
      <span slot="title">{{ $t("CONFIRM_DELETE_POLICY") }}?</span>
    </delete-dialog>
  </div>
</template>

<script>
import AddCancellation from "./AddCancellation.vue";
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { service } from "@/_services/HotelSetting/cancellation-payment.service.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";

export default {
  components: {
    "add-cancellation": AddCancellation,
    paging: Paging,
    "delete-dialog": DeleteDialog
  },
  data() {
    return {
      currency: this.usedCurrency,
      sysLang: this.$i18n.locale,
      isListingPage: true,
      dialog: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "",
          value: "stt"
        },
        {
          text: this.$t("POLICY_NAME"),
          class: "",
          value: "name"
        },
        { 
          text: this.$t("POLICY_DESCRIPTION"), 
          value: "percent"
        },
        {
          text: this.$t("STATUS"),
          class: "text-center",
          value: "detail"
        },
        { 
          text: this.$t("ACTION"), 
          value: "action", 
          class: "text-center"
        }
      ],
      data: [],
      dataTable: [],
      editedIndex: -1,
      editedItem: null,
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      totalItems: null
    };
  },

  async created() {
    this.initialize();
  },
  watch: {
    totalItems(value) {
      this.paging.total = value;
    }
  },
  methods: {
    initialize(params) {
      if (!params) {
        params = {
          limit: 15,
          offset: 0
        };
      }
      service.get(params).then(res => {
        this.data = res.data;
        // this.totalItems = res.total;

        this.paging.total = res.total;
        this.dataTable = res.data;
      });
    },
    addCancellation() {
      this.$router.push({ name: "editCancellationPolicy", params: { id: 0 } });
    },
    changePage(paging) {
      this.paging = paging;
       let params = {
            limit: 15,
            offset: this.paging.offset
        };
      this.initialize(params);
    },
    editItem(item) {
      this.$router.push({
        name: "editCancellationPolicy",
        params: { id: item.id }
      });
    },
    changeStatus(item) {
      service.update(item).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    },
    deleteItem(item) {
      const index = this.data.indexOf(item);
      service.remove(item.id).then(res => {
        if (res.responseCode == 0) {
          this.totalItems -= 1;
          let params = {
            limit: 15,
            offset: this.paging.offset
          };
          this.initialize(params);
        }
        _alert(res, this.$t(res.data), false);
        this.$refs.deleteDialogComponent.close();
      });
    },
    redirect() {
      this.isListingPage = !this.isListingPage;
    },
    _formatCurrency: _formatCurrency
  }
};
</script>
